import './styles.scss';

import { faBars, faGripDots } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import {
  DraggableItem,
  DraggrableContainer,
  ItemDraggableType,
} from '../../../../../../components/draggable';
import { Dropdown } from '../../../../../../components/dropdown/dropdown';
import { OrderItemType } from '../../../../../../providers/risk-management/risk-filters-provider';

interface Props {
  items: OrderItemType[];
  setItems: React.Dispatch<React.SetStateAction<OrderItemType[]>>;
  defaultOrderRowsList: any[];
  riskType: string;
}

const ReorderTableMenu = (props: Props) => {
  const { items, setItems, defaultOrderRowsList, riskType } = props;
  const [itemsList, setItemsList] = useState<ItemDraggableType[]>([]);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const onClose = () => {
    if (open) {
      setItemsList(items);
    }
  };

  const handleOnCancel = () => {
    onClose();
    setOpen(false);
  };

  const handleOnApply = () => {
    setItems(
      itemsList.map((itemList) => ({
        id: itemList.id.toString(),
        label: itemList.label,
      })),
    );
    setOpen(false);
  };

  useEffect(() => {
    setItemsList(items);
  }, [items, setItemsList, riskType]);

  useEffect(() => {
    const dropdown: any = dropdownRef.current;

    if (!dropdown) return;

    if (open) {
      const rect = dropdown.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.top;
      const minimumDistanceToBottom = 40;

      if (spaceBelow < dropdown.clientHeight) {
        const topValue = -(dropdown.clientHeight - spaceBelow + minimumDistanceToBottom);
        dropdown.style.top = `${topValue}px`;
      }
    } else {
      dropdown.style.top = `unset`;
      dropdown.style.bottom = `unset`;
    }
  }, [open, dropdownRef]);

  const renderListItems = () => {
    return itemsList.map((item, i) => {
      return (
        <div key={i.toString()}>
          <DraggableItem id={item.id.toString()}>
            <div className="item-list">
              <FontAwesomeIcon icon={faGripDots} className="icon" />
              <span>{item.label}</span>
            </div>
          </DraggableItem>
        </div>
      );
    });
  };

  const resetToDefault = () => {
    setItemsList(defaultOrderRowsList);
  };

  const renderResetButton = () => {
    const isDisabled = defaultOrderRowsList === itemsList;

    return (
      <Button className="reset-button" onClick={resetToDefault} disabled={isDisabled}>
        Reset to default
      </Button>
    );
  };

  return (
    <div className="reorder-table-menu">
      <div
        className="bt-open"
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      >
        <FontAwesomeIcon icon={faBars} className="icon" />
        <span>Table rows</span>
      </div>
      <Dropdown
        isOpen={open}
        setIsOpen={setOpen}
        classNames="dropdown-class"
        ref={dropdownRef}
        onClose={onClose}
      >
        <div className="content">
          <div className="menu-header">
            <span className="menu-header-title">Sort table rows</span>

            {renderResetButton()}
          </div>

          <div className="list-items">
            <DraggrableContainer items={itemsList} setItems={setItemsList}>
              {renderListItems()}
            </DraggrableContainer>
          </div>

          <div className="buttons">
            <Button className="cancel-button" onClick={handleOnCancel}>
              Cancel
            </Button>
            <Button className="apply-button" onClick={handleOnApply}>
              Apply
            </Button>
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default ReorderTableMenu;
